import {usePromotion} from '../../../service/promotions/promotions-hook';
import {PublicationPreview} from '../../publication-preview/publication-preview';
import {YandexStoriesCarousel} from '../../stories/yandex-stories-preview/carousel/yandex-stories-carousel';

import {PromotionInfo} from './promotion-info';

type PropsType = {
    activePromotionId: number | null;
    onClose: VoidFunction;
};

export function PromotionPreview({activePromotionId, onClose}: PropsType): JSX.Element | null {
    const {data: promotion, isFetching} = usePromotion(activePromotionId, true);

    if (!activePromotionId) {
        return null;
    }

    const isLoading = isFetching || !promotion;

    return (
        <PublicationPreview
            info={promotion && <PromotionInfo onClose={onClose} promotion={promotion} />}
            isLoading={isLoading}
            media={
                promotion &&
                promotion.images.length > 0 && (
                    <YandexStoriesCarousel
                        slides={promotion.images.map((image) => ({image: {url: image.url}}))}
                        storyName={promotion.title}
                    />
                )
            }
            onClose={onClose}
        />
    );
}
